export function Rewind2Icon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <g clipPath="url(#clip0_2_2695)">
        <path
          fill="currentColor"
          d="M11 13.732l-7.5 4.33a1 1 0 01-1.5-.866V6.804a1 1 0 011.5-.866l7.5 4.33V6.804a1 1 0 011.5-.866l9 5.196a1 1 0 010 1.732l-9 5.196a1 1 0 01-1.5-.866v-3.464z"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_2_2695">
          <path fill="currentColor" d="M0 0H24V24H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
}
